export default "__VITE_ASSET__DBk9LDOs__"